import firebase from "firebase/app";
import "firebase/app";
import "firebase/auth";
import "firebase/database";
import "firebase/storage";
import "firebase/messaging";
import "firebase/firestore";
import "firebase/functions";

import nobleFirebaseConfig from "./firebaseConfig/nobleFirebaseConfig";
// Add the Firebase products that you want to use

let firebaseConfig = nobleFirebaseConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

export const database = firebase.database();
export const auth = firebase.auth();
// FCM web push is not available on older Mobile Safari; guard to avoid runtime errors.
export const messaging = firebase.messaging.isSupported()
  ? firebase.messaging()
  : null;
export const firestore = firebase.firestore();
export const storage = firebase.storage();
export const functions = firebase.functions();

// Local development: route callable calls to the Functions emulator instead of
// the deployed functions, so changes to functions/ don't require a deploy. Opt
// in explicitly so production builds are never affected:
//   REACT_APP_USE_FUNCTIONS_EMULATOR=true npm start
if (process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true") {
  const fns = functions as any;
  if (typeof fns.useEmulator === "function") {
    fns.useEmulator("localhost", 5001);
  } else if (typeof fns.useFunctionsEmulator === "function") {
    // firebase <8.4 compat API
    fns.useFunctionsEmulator("http://localhost:5001");
  }
  // eslint-disable-next-line no-console
  console.log("[firebase] callables -> Functions emulator (localhost:5001)");
}

export default firebase;
